module.exports = __webpack_public_path__ + "static/c8-2315469dfffb7dcfec454e3a291c8e50.png";